import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'sage' | 'forest';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-[#FDF8F0]',
    white: 'bg-[#FAFAF7]',
    sage: 'bg-[#E8EDE6]',
    forest: 'bg-[#2D3B2D] text-[#FDF8F0]'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-8 ${backgrounds[background]} ${className}`} data-id="element-147">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-148">
        {children}
      </motion.div>
    </section>;
}